import { WatchLater, CheckCircleRounded, Psychology, Money } from "@mui/icons-material";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { Stack } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import JobDetailsModal from "../../JobList Components/JobDetailsModal";
import "./Job.css";
import { heading, bodyText, cardSx } from "../../../store/presetsNew";
import { tokens } from "../../../store/tokens";

const JobShortCard = ({ jobData }) => {
  const navigate = useNavigate();
  const {
    job_budget,
    job_title,
    job_currency,
    job_expertlevel,
    job_time,
    job_info,
    poster_locat,
    poster_status,
    job_skill,
    job_id,
    job_refer,
    job_poster,
    job_poster_name,
  } = jobData;

  // Parse skills safely, fallback to empty array
  let skill = [];
  try {
    skill = JSON.parse(job_skill?.split(", ") || "[]");
  } catch {
    skill = [];
  }

  const [jobId, setJobId] = useState("");
  const [jobRefer, setJobRefer] = useState("");
  const [poid, setPoid] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  const handleModalOpen = (refer, id, poid) => {
    setJobId(id);
    setJobRefer(refer);
    setPoid(poid);
    setModalOpen(!modalOpen);
  };

  const skillTagSx = {
    bgcolor: tokens.color.teal,
    color: tokens.color.white,
    textTransform: "capitalize",
    borderRadius: `${tokens.radius.pill}px`,
    px: 1.75,
    py: 0.5,
    fontFamily: tokens.font.body,
    fontSize: 11,
    fontWeight: 600,
    cursor: "pointer",
    transition: "background-color 0.2s ease",
    "&:hover": { bgcolor: tokens.color.tealDark },
  };

  return (
    <>
      <Paper
        elevation={0}
        onClick={() => navigate(`/JobDetails/${job_id}/${job_refer}/${job_poster}`)}
        sx={{
          ...cardSx("elevated"),
          cursor: "pointer",
          p: 2,
          mb: 2,
          transition: "transform 0.2s ease, box-shadow 0.3s ease, border-color 0.25s ease",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: tokens.card.elevated.shadowHover,
            borderColor: tokens.card.elevated.borderHover,
          },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Stack spacing={1}>
              {/* Job Title */}
              <Typography
                sx={{
                  ...heading("h6"),
                  maxWidth: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {job_title}
              </Typography>

              {/* Budget */}
              <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.5 }}>
                <Money sx={{ fontSize: 16, color: tokens.color.teal }} />
                <Typography sx={{ ...bodyText("body2", tokens.color.ink), fontSize: 16 }}>
                  {job_currency} {job_budget}
                </Typography>
              </Stack>

              {/* Expert Level and Time */}
              <Stack direction="row" spacing={3} alignItems="center">
                <Stack direction="row" spacing={0.5} alignItems="center">
                  <Psychology fontSize="small" sx={{ color: tokens.color.teal }} />
                  <Typography sx={{ ...bodyText("body2") }}>{job_expertlevel}</Typography>
                </Stack>

                <Stack direction="row" spacing={0.5} alignItems="center">
                  <WatchLater fontSize="small" sx={{ color: tokens.color.teal }} />
                  <Typography sx={{ ...bodyText("body2") }}>{job_time}</Typography>
                </Stack>
              </Stack>

              {/* Job Info */}
              <Typography
                sx={{
                  ...bodyText("body2"),
                  mt: 0.5,
                  maxHeight: 48,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {job_info?.length > 60 ? `${job_info.slice(0, 60)}...` : job_info}
              </Typography>

              {/* Poster Info */}
              <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.5 }}>
                <CheckCircleRounded
                  sx={{
                    fontSize: 16,
                    color: poster_status === "1" ? tokens.color.success : tokens.color.inkFaint,
                  }}
                />
                <Typography sx={{ ...bodyText("body2") }}>{job_poster_name}</Typography>
                <Box
                  sx={{
                    width: 4,
                    height: 4,
                    borderRadius: "50%",
                    bgcolor: tokens.color.inkFaint,
                  }}
                />
                <Typography sx={{ ...bodyText("body2") }}>{poster_locat}</Typography>
              </Stack>

              {/* Skills */}
              <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 0.5, minHeight: 25 }}>
                {skill.length > 1 ? (
                  skill.slice(0, 2).map((element) => (
                    <Box
                      key={element}
                      component="span"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate("/joblist");
                      }}
                      sx={skillTagSx}
                    >
                      {element}
                    </Box>
                  ))
                ) : (
                  <Box
                    component="span"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate("/joblist");
                    }}
                    sx={skillTagSx}
                  >
                    Join Work
                  </Box>
                )}
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Paper>

      {/* Modal for job details */}
      <JobDetailsModal
        jobId={jobId}
        jobRefer={jobRefer}
        poid={poid}
        modalOpen={modalOpen}
        handleModalOpen={handleModalOpen}
      />
    </>
  );
};

export default JobShortCard;